export const UnderlineInput = React.createClass({
	displayName: 'UnderlineInput',
	propTypes: {
		inputType: React.PropTypes.string,
		onChange: React.PropTypes.func,
		onKeyPress: React.PropTypes.func
	},
	getDefaultProps() {
		return {
			value: '',
			inputType: 'text',
			placeHolder: 'Input some text',
			onChange: function() {},
			onKeyPress: function() {}
		}
	},
	render() {
		return (
			<div className="underline-input">
				<div className="underline-input-wrapper">
					<input 
						className="underline-input-input" 
						type={this.props.inputType} 
						value={this.props.value} 
						placeholder={this.props.placeHolder} 
						onChange={this.props.onChange} 
						onKeyPress={this.props.onKeyPress}
						/>
				</div>
			</div>
		);
	}
});


// WEBPACK FOOTER //
// ../modules/js/v3/components/underline_input.js